export { default } from "../src/page-british-columbia";
